$(document).ready(function(){
  var filterStatus = false;
  function returnRefinedURL (key, url) {
    var urlParts = url.split('?');
    if (urlParts.length === 1 || url.indexOf(key) === -1 ) {
      return url;
    } else {
      var keyValues = urlParts[1].split('&'),
          refinedKeyValues = keyValues.filter(function (keyValuePair) {
            return keyValuePair.indexOf(key) !== 0;
          }).join('&');
    }
    if(refinedKeyValues == ''){
      return urlParts[0]; 
    }else{
      return urlParts[0] + '?' + refinedKeyValues; 
    }        
  }

  function getd(currentURL, _this){    
    window.history.replaceState(null, null, currentURL);
    $.get(currentURL, function( data ) {          
      if ($(window).width() > 830 || _this.is("[data-clearall]") || _this.is("[data-facet-remove]") || _this.is("#sort-by")){
        $('body').find('[data_collectionWPgrid]').html($(data).find('[data_collectionWPgrid]').html());
        if (!_this.is("#sort-by")){
          var speed = $('.new_cms_conatiner').offset().top*2;
          $('html,body').animate({
            scrollTop: $('.new_cms_conatiner').offset().top
          }, speed);
        }
      }
      if ($(window).width() > 830 && filterStatus == true){
        $('.collections_filters_button button').click();
      }
    });
  }

  //  infinite scrolling function start 
  var screenLoading = false;
  var screenDelay = 100;

  function scrollExecute() {
    if($(document).height() - 1500 < ($(document).scrollTop() + $(window).height())) {
      var loadingImage;
      var scrollNode = $('.collection-loader .load_more');
      var scrollUrl = $('.collection-loader .load_more').attr("href");
      if(scrollNode.length > 0 && scrollUrl != '') {
        $.ajax({
          type: 'GET',
          url: scrollUrl,
          beforeSend: function() {
            $('.collection-loader').empty();
          },
          success: function(data) {
            var filteredData = $(data).find(".custom_scroll_wrap").html();
            var load_btn = $(data).find(".collection-loader").html();
            $(".custom_scroll_wrap").append(filteredData);
            $(".collection-loader").html(load_btn);
          },
          dataType: "html"
        });
      }
    }
  }
  //  infinite scrolling function end
  
  $('body').on('click','.collections_filters_button button', function() {
    $('[data_collectionWPgrid] .collections_products_gird').toggleClass("active_filter");
    // $('[data_collectionWPgrid]').toggleClass("active_filter");
    $('.collections_filters_button').toggleClass("active_filter_button");
    $('body').toggleClass('filter-open');
    if ($('.collections_filters_button').hasClass('active_filter_button')){
      $(this).find('span').html('Ocultar filtros'); 
      filterStatus = true;
    } else {
      $(this).find('span').html('Mostrar filtros'); 
      filterStatus = false;
    }
  });

  $('body').on('click','.show_more_options button',function(e){
    e.preventDefault();
    if ($(this).html() == 'Show more +' || $(this).html() == 'Mostrar más +'){
      $(this).parents('.filter_options_ul').find('li.hide-option').show();
      if ($(this).html() == 'Show more +'){ $(this).html('Show less -'); } else { $(this).html('Muestra menos -'); }
    } else if ($(this).html() == 'Show less -' || $(this).html() == 'Muestra menos -'){
      $(this).parents('.filter_options_ul').find('li.hide-option').hide();
      if ($(this).html() == 'Show less -' ){ $(this).html('Show more +'); } else { $(this).html('Mostrar más +'); }
    }
  });

  $('body').on('click','[data-filter_form_label]',function(e){       
    e.preventDefault();
    
    $(this).parent('li').removeClass('disabled');
    if($(this).parent('li').hasClass('active_filter') ){
      $(this).removeClass('selected');
      $(this).parent('li').removeClass('active_filter');  
    }else {
      $(this).addClass('selected');
      $(this).parent('li').addClass('active_filter');  
    }
    
    var href = $(this).attr('name');  
    var val = $(this).attr('value');  
    
    if(val != undefined && val != ''){
      if(val.indexOf(' ') >= 0){
        val = val.replaceAll(' ','+');
      }
      if(val.indexOf('#') >= 0){
        val = val.replaceAll('#','%23');
      }
      if(val.indexOf('/') >= 0){
        val = val.replaceAll('/','%2F');
      }
      
    var originalURL = new URL(window.location.href);
    originalURL.searchParams.delete("page");
    var currentURL = originalURL.href, finalVAL = href+'='+val, is_current = false, without_cur = [], params = {}, parser = document.createElement('a');
    parser.href = originalURL.href;
    var query = parser.search.substring(1), vars = query.split('&');  

    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if(val.indexOf('"') >= 0){
        val = val.replaceAll('"','%22');
      }
      if(encodeURI(href) == pair[0] && val == pair[1]){
        is_current = true;
      }else{
        without_cur.push(pair[0] + '=' + pair[1]);
      }
    }
    if(is_current){    
      currentURL = (currentURL.indexOf('?') > -1) ? currentURL.split('?')[0] : currentURL;
      if(without_cur.length > 0){
        currentURL = currentURL + '?' +without_cur.join('&')           
      }else{                            
        currentURL = currentURL;              
      }            
    }else{                    
      if(currentURL.indexOf('?') >= 0){
        currentURL = currentURL + '&' + finalVAL;
      }else{
        currentURL = currentURL + '?' + finalVAL;
      } 
    }
    getd(currentURL, $(this)); 
  }
 });

  var typingTimer;  //timer identifier
  var doneTypingInterval = 2000;  //time in ms, 5 second for example

  $('body').on('keyup','[data-price-filter]',function(e){
    var max = parseInt($(this).attr('max')), _this = $(this), href = _this.attr('name'), val = _this.val(), charCode = (e.which) ? e.which : e.keyCode;        
    $('.outerr').remove();
    if ((charCode > 8 && charCode < 20)) {
      e.preventDefault();          
      return false;          
    }                
    if(parseInt(val) > max){
      $(this).parents('price-range').after('<p class="outerr" style="color: red;">Please add below the number of max price.</p>');
      e.preventDefault();          
      return false;
    }

    var originalURL = new URL(window.location.href);
        originalURL.searchParams.delete("page");
    var currentURL = originalURL.href;
    
    typingTimer = setTimeout(function(){  
      $('[data-price-filter]').each(function(i, ele){  
        var finalVAL = $(ele).attr('name')+'='+$(ele).val();  
        
        currentURL = returnRefinedURL(encodeURI($(ele).attr('name')), currentURL);
        if(currentURL.indexOf('?') >= 0){
          currentURL = currentURL + '&' + finalVAL;
        }else{
          currentURL = currentURL + '?' + finalVAL;
        } 
      });
      getd(currentURL, $(this));
    }, doneTypingInterval);
  });

  $('body').on('click','[data-clearall], [data-facet-remove]',function(e){
    e.preventDefault();
    getd($(this).data('href'), $(this));     
    if ($(window).width() <= 830 && $(this).parents('.mob_Clear_filter').length == 0){
      $('.close_filter > a').click();
    }
  });
  
  $("body").on("click",'.filter_header_wrp', function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).next(".filter_options_ul").slideUp(200); 
    } else { 
      $(this).addClass("active");
      $(this).next(".filter_options_ul").slideDown(200);
    }
  }); 
  
  $('body').on('click','.ft_mobile_btn.apply',function(){
    $.get(window.location.href, function(data) {          
        $('body').find('[data_collectionWPgrid]').html($(data).find('[data_collectionWPgrid]').html());
        var speed = $('.new_cms_conatiner').offset().top*2;
        $('html,body').animate({
          scrollTop: $('.new_cms_conatiner').offset().top
        }, speed);
    });
    $('.collections_filters_button button').click();
  });

  $('body').on('click','.close_filter > a',function(e){
    e.preventDefault();
    $('.collections_filters_button button').click();
  });
  
  // SORT BY START
  $('body').on('change','#sort-by',function(){
    var finalVAL = 'sort_by='+$(this).val(), originalURL = new URL(window.location.href), href = 'sort_by';
    var currentURL = originalURL.href
    currentURL = returnRefinedURL(encodeURI(href), currentURL);
    if(currentURL.indexOf('?') >= 0){
      currentURL = currentURL + '&' + finalVAL;
    }else{
      currentURL = currentURL + '?' + finalVAL;
    }
    getd(currentURL, $(this));
  });
  // SORT BY END

  //  infinite scrolling start 
  $(window).scroll(function(){
    setTimeout(function(){
      scrollExecute();
    }, screenDelay );
    if( $(document).height() - 1500 > $(document).scrollTop() + $(window).height() ) {
      screenDelay = 100;
    }
  }); 
  //  infinite scrolling end   
});
$(window).scroll(function() {  
var scroll = $(window).scrollTop();
// Sort sticky for mobile - facets.js
     if($('.collections_filters').length > 0){
       if ($(window).width() <= 830){
         var hh = $('.top_collections_wrapper').outerHeight();
         if (scroll >= hh) {
              $(".top_collections_wrapper").addClass("sticky-on");
          } else {
              $(".top_collections_wrapper").removeClass("sticky-on");
          }
       }
     }
     // Sort sticky for mobile - facets.js
});